import React, { useState, useEffect } from "react";
import BikeIcon from "../../assets/icons/bike-new.png";
import CarIcon from "../../assets/icons/car.png";
import CommercialIcon from "../../assets/icons/commercial.png";
import goodsCarry from "../../assets/transport-truck.png";
import passCarry from "../../assets/passanger-carry.png";
import LifeIcon from "../../assets/icons/insurance.png";
import HealthIcon from "../../assets/icons/health.png";
import TravelIcon from "../../assets/icons/travel.png";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
// import { LazyLoadImage } from "react-lazy-load-image-component";
// import "react-lazy-load-image-component/src/effects/blur.css";
import { Popover } from "antd";
import axiosInPosp from "../../Redux/axios/AxiosInPosp";
import {
  setCommercialDetails,
  getCommercialDetails,
} from "../../Redux/actions/CommercialSlice";
import { addProductType } from "../../Redux/actions/NumBikeation";
// import "./Home.css";
const insuranceList = [
  {
    id: "car",
    name: "Car",
    image: CarIcon,
    isactive: true,
    applink: "/carno",
    pospLink: "/OfflineCar",
    desc: "PRIVATE CAR",
    displaycontent: (
      <div className="col-sm-12 col-lg-10 col-xl-10">
        <h5 className="text-white mb-3">
          Save upto 85%* on Four Wheeler Insurance
        </h5>
        <p className="text-white my-3">Stay home & renew in 2 minutes</p>
      </div>
    ),
    displaycontent2: "",
    // (
    //   <div className="col-sm-12 col-lg-10 col-xl-10 insurance__info-card p-3 rounded text-left my-3">
    //     <h6>Looking to insure brand new car?</h6>
    //     <Link to="" className="mb-0">
    //       View plans
    //     </Link>
    //   </div>
    // ),
  },
  {
    id: "bike",
    name: "2 wheeler",
    image: BikeIcon,
    isactive: true,
    applink: "/bikeno",
    pospLink: "/PospNum",
    desc: "TWO WHEELER",
    displaycontent: (
      <div className="col-sm-12 col-lg-10 col-xl-10">
        <h5 className="text-white mb-3">Bike insurance starting at ₹555</h5>
        <p className="text-white my-3">
          Save upto 85%* on Two Wheeler Insurance, Stay home & renew in 2
          minutes
        </p>
      </div>
    ),
    // displaycontent2: (
    //   <div className="col-sm-12 col-lg-10 col-xl-10 insurance__info-card p-3 rounded text-left my-3">
    //     <h6>Looking to insure brand new two wheeler?</h6>
    //     <Link to="" className="mb-0">
    //       View plans
    //     </Link>
    //   </div>
    // ),
  },

  // {
  //   id: "gcv",
  //   name: "GCV",
  //   desc: "GOODS COMMERCIAL VEHICLE",
  //   image: goodsCarry,
  //   isactive: true,
  //   applink: "/commercialno",
  //   // pospLink: "/Offlinecommercial",
  //   displaycontent: (
  //     <div className="col-sm-12 col-lg-10 col-xl-10">
  //       <h5 className="text-white mb-3">
  //         Save upto 85%* on Commercial Insurance
  //       </h5>
  //       <p className="text-white my-3">Stay home & renew in 2 minutes</p>
  //     </div>
  //   ),
  //   displaycontent2: "",
    // (
    //   <div className="col-sm-12 col-lg-10 col-xl-10 insurance__info-card p-3 rounded text-left my-3">
    //     <h6>Looking to insure brand new car?</h6>
    //     <Link to="#" className="mb-0">
    //       View plans
    //     </Link>
    //   </div>
    // ),
  // },

// {
//   id: "pcv",
//   name: "PCV",
//   desc: "PASSENGER CARRYING VEHICLE",
//   image: passCarry,
//   isactive: true,
//   applink: "/commercialno",
//   // pospLink: "/Offlinecommercial",
//   displaycontent: (
//     <div className="col-sm-12 col-lg-10 col-xl-10">
//       <h5 className="text-white mb-3">
//         Save upto 85%* on Commercial Insurance
//       </h5>
//       <p className="text-white my-3">Stay home & renew in 2 minutes</p>
//     </div>
//   ),
//   displaycontent2: "",
// },
// {
//   id: "misc-d",
//   name: "Misc-D",
//   desc: "MISCELLANEOUS VEHICLE",
//   image: CommercialIcon,
//   isactive: true,
//   applink: "/commercialno",
//   // pospLink: "/Offlinecommercial",
//   displaycontent: (
//     <div className="col-sm-12 col-lg-10 col-xl-10">
//       <h5 className="text-white mb-3">
//         Save upto 85%* on Commercial Insurance
//       </h5>
//       <p className="text-white my-3">Stay home & renew in 2 minutes</p>
//     </div>
//   ),
//   displaycontent2: "",
// },
// {
//   id: "life",
//   name: "Life",
//   image: LifeIcon,
//   isactive: true,
//   applink: "/lifeno",
//   pospLink: "/lifeOffline",
//   displaycontent: (
//     <div className="col-sm-12 col-lg-10 col-xl-10">
//       <h5 className="text-white mb-3">
//         Your Shield in Life's Uncertainties: Insurance for Every Stage
//       </h5>
//       <p className="text-white my-3">Save upto 85%* on Life Insurance</p>
//     </div>
//   ),
//   displaycontent2: "",
//   // (
//   //   <div className="col-sm-12 col-lg-10 col-xl-10 insurance__info-card p-3 rounded text-left my-3">
//   //     <h6>Looking to insure brand new car?</h6>
//   //     <Link to="#" className="mb-0">
//   //       View plans
//   //     </Link>
//   //   </div>
//   // ),
// },
{
  id: "health",
    name: "Health",
      image: HealthIcon,
        isactive: true,
          applink: "https://health.vibeins.com/healthinsurancepremium#",
            pospLink: "",
              displaycontent: (
                <div className="col-sm-12 col-lg-10 col-xl-10">
                  <h5 className="text-white mb-3">
                    Protecting What Matters Most: Your Trusted Insurance Partner
                  </h5>
                  <p className="text-white my-3">Save upto 85%* on Health Insurance</p>
                </div>
              ),
                displaycontent2: "",
  },
  // {
  //   id: "travel",
  //   name: "Travel",
  //   image: TravelIcon,
  //   isactive: false,
  //   // applink: "/travelno",
  //   displaycontent: (
  //     <div className="col-sm-12 col-lg-10 col-xl-10">
  //       <h5 className="text-white mb-3">
  //         Safety, Assurance, and Beyond: Unlocking Your Peace of Mind
  //       </h5>
  //       <p className="text-white my-3">Save upto 85%* on Travel Insurance</p>
  //     </div>
  //   ),
  //   displaycontent2: "",
  // },
];
function HomeBanner() {
  const history = useHistory();
  const [active, setactive] = useState("");
  const CommercialDetails = useSelector(getCommercialDetails);

  const PospDetail = useSelector((state) => state?.posp?.Posp);
  const ONBDetails = useSelector((state) => state?.posp?.onbDetails);
  const TokExp = useSelector((state) => state?.common?.pospTokenExp);
  const dispatch = useDispatch();
  const [user, setuser] = useState("");
  const [profData, setProfData] = useState("");
  console.log("PospDetail", PospDetail);
  // console.log("active", active);

  const dispatchHome = () => {
    if (active?.name === "Bike") {
      dispatch({ type: "RESET_CAR" });
      // dispatch({ type: "RESET_COMMON" });
    } else if (active?.name === "Car") {
      dispatch({ type: "RESET_BIKE" });
      // dispatch({ type: "RESET_COMMON" });
    } else if (active?.name === "Commercial") {
      dispatch({ type: "RESET_CAR" });
      dispatch({ type: "RESET_BIKE" });
    }
  };
  dispatchHome();
  useEffect(() => {
    const isuser = PospDetail?.name;
    console.log("TokExp", TokExp);
    if (TokExp) {
      setuser("");
    } else if (TokExp === false) {
      setuser(PospDetail);
    }
    fetchStates();
  }, [PospDetail, TokExp]);
  // console.log("!user", !user);
  // console.log("user", user);
  const fetchStates = () => {
    axiosInPosp
      .get(`v1/posp/profile/edit`)
      .then((res) => {
        console.log(res);
        if (res?.status === 200) {
          const ProfData = res?.data?.profile;
          // console.log("ProfData", ProfData);
          setProfData(ProfData);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err?.response?.data?.message === "Unauthenticated.") {
          dispatch({ type: "LOGOUT_POSP" });
          // history.push("/");
        }
      });
  };
  const onProductClick = (ins) => {
    console.log("ins", ins);
    setactive(ins);
    dispatch(addProductType(ins.desc));
    if (ins.name === "GCV" || ins.name === "PCV" || ins.name === "Misc-D") {
      dispatch(
        setCommercialDetails({
          ...CommercialDetails,
          commercialType: ins.desc,
        })
      );
    }
    // if (ins?.applink.startsWith("http")) {
    //   window.open(ins.applink, "_blank");
    // } else {
    //   history.push(ins?.applink);
    // }
  };
  const content = (
    <div>
      <p className="mb-0">SingnUp POSP and Complete the KYC to create Quote.</p>
    </div>
  );
  return (
    <div className="home_banner">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-lg-6 col-md-6 col-xl-6">
            <div className="w-100 h-100 text-center d-flex flex-column justify-content-center flex-wrap mb-5">
              <div className="insure_card--list">
                {insuranceList?.map((insurance, i) => {
                  return (
                    <div
                      key={insurance.id}
                      className={`insure_card ${active.id === insurance.id ? "active" : ""
                        }`}
                      onClick={() => onProductClick(insurance)}
                    >
                      {!user ? (
                        <Popover
                          className="popConthome"
                          // content={content}
                          trigger="click"
                        >
                          <img
                            src={insurance.image}
                            alt="logo"
                            className="mb-2"
                          ></img>
                        </Popover>
                      ) : (
                        <img
                          src={insurance.image}
                          alt="logo"
                          className="mb-2"
                        ></img>
                      )}
                      <h6>{insurance?.name}</h6>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-xl-6 text-center">
            <p className="text-white mb-2">Let us help you find the</p>
            <h1 className="mb-0">
              Best <span>{active?.name}</span> Insurance
            </h1>
            <div className="col-sm-12 col-lg-12 px-2 px-md-5 py-5 d-flex justify-content-center align-items-center">
              {active?.displaycontent}
              {active?.displaycontent2}
            </div>
            <div className="col-sm-12 col-lg-12 px-2 px-md-5 d-flex justify-content-center align-items-center">
              <div className="text-center d-flex gap-3">
                {/* {active?.isactive === true && profData?.kyc_status?.id >= 6 ? ( */}
                {active?.isactive === true && PospDetail?.isPOSP === true ? (
                  <>
                    {active?.applink.startsWith("http") ? (
                      <a
                        href={active?.applink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <button className="btn btn-warning btn-lg mb-3">
                          Get Quote
                        </button>
                      </a>
                    ) : (
                      <Link to={active?.applink}>
                        <button className="btn btn-warning btn-lg mb-3">
                          Get Quote
                        </button>
                      </Link>
                    )}
                    {/* {active?.pospLink ? (
                      <Link to={active ? active?.pospLink : null}>
                        <button className="btn btn-warning btn-lg mb-3">
                          Go Ofline Quote
                        </button>
                      </Link>
                    ) : null} */}
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeBanner;
